var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_299_1136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5912 17.9734C14.2091 19.0218 13.0929 19.7909 11.8689 19.8278C10.3618 19.8743 9.11823 19.1872 8.56987 17.7438C8.18779 16.7387 8.18249 15.708 8.37353 14.6724C8.62825 13.2916 9.18899 12.0297 10.2273 10.9732C10.8411 10.3487 11.5682 9.88306 12.5092 9.76747C12.7126 9.74338 12.9249 9.74499 13.1283 9.76747C13.3884 9.79797 13.4998 9.96174 13.4326 10.1929C13.3388 10.5189 13.2486 10.8464 13.1266 11.1643C13.0876 11.2686 12.9656 11.4019 12.8612 11.4212C11.8494 11.6074 11.3117 12.2641 10.8977 13.0315C10.6678 13.457 10.5015 13.9098 10.2822 14.4075C11.6301 14.0029 12.7993 14.149 13.781 14.9758C14.7575 15.7963 15.0051 16.8302 14.5877 17.9718L14.5912 17.9734Z",
    fill: "#38BB9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6941 17.577C21.4612 18.7243 20.4733 19.6358 19.2871 19.7978C17.693 20.0161 16.3218 19.1094 15.8774 17.5128C15.4743 16.0702 15.6428 14.6485 16.1434 13.2573C16.5415 12.1501 17.1445 11.1648 18.1076 10.4251C18.666 9.99505 19.2954 9.73029 20.0256 9.75115C20.4633 9.76559 20.574 9.91643 20.4567 10.3208C20.3774 10.6 20.3114 10.8856 20.2089 11.1552C20.166 11.2643 20.052 11.4055 19.9496 11.4264C19.2244 11.566 18.7519 12.0169 18.3769 12.5898C18.02 13.1353 17.7871 13.7323 17.5971 14.4014C18.5883 14.0548 19.4936 14.1366 20.3527 14.6229C21.3918 15.2134 21.9303 16.4136 21.6941 17.5738V17.577Z",
    fill: "#38BB9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_299_1136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.5,
    height: 10.5,
    fill: "white",
    transform: "translate(8.25 9.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteIcon);
export default __webpack_public_path__ + "static/media/quoteIcon.6534d5ced6e0adf95192dd262e3531d4.svg";
export { ForwardRef as ReactComponent };